const defaultProfilePrefix = window.location.origin + "/creators/";
const defaultProjectPrefix = window.location.origin + "/projects/";

export { defaultProfilePrefix, defaultProjectPrefix };

const domain_url_prefix = "https://test-assets.collab-with-lynx.com";

export const defaultSkillImage = `${domain_url_prefix}/general/default-skill-image.png`;
export const defaultProfileImageSquare = `${domain_url_prefix}/profile-picture-user-177-v-1717155053408`;
export const defaultProfileImageCircl = `${domain_url_prefix}/profile-picture-user-177-v-1717155164030`;

export const creatorDefaultImages = {
  "Performance & Modeling":
    "/retoolUploads/retool-uploadsDefault_Performance.png",
  "Street, Skate & Surf":
    "/retoolUploads/retool-uploadsDefault_Street%20Arts.png",
  "TV & Film Making": "/retoolUploads/retool-uploadsDefault_Film%20TV.png",
  Music: "/retoolUploads/retool-uploadsDefault_Music.png",
  "Fine Arts": "/retoolUploads/retool-uploadsDefault_Fine%20Arts.png",
  Fashion: "/retoolUploads/retool-uploadsDefault_Fashion.png",
  "Architecture & Space Design":
    "/retoolUploads/retool-uploadsDefault_Architecture_Space_Planning.png",
  "Culinary Arts": "/retoolUploads/retool-uploadsDefault_Culinary%20Arts.png",
  "Digital Art": "/retoolUploads/retool-uploadsDefault_Digital%20Arts.png",
  "Beauty & Styling":
    "/retoolUploads/retool-uploadsDefault_Beauty%20Styling.png",
  "Marketing ": "/retoolUploads/retool-uploadsDefault_Marketing.png",
  Technology: "/retoolUploads/retool-uploadsDefault_Technology.png",
  "Writing & Story Telling": "/retoolUploads/retool-uploadsDefault_Writing.png",
  "Product Design ":
    "/retoolUploads/retool-uploadsDefault_Product%20Design.png",
  Management: "/retoolUploads/retool-uploadsDefault_Management.png",
  "Events & Touring": "/retoolUploads/retool-uploadsDefault_Events.png",
};

export const server_link = process.env.REACT_APP_LYNX_SERVER;
export const node_server = process.env.REACT_APP_NODE_SERVER;

export const CommunityGuidlines_Url =
  "https://uploads-ssl.webflow.com/651750892fc953e528ca7b72/65a28b6d7c89e05bfa45b376_LYNX%20Community%20Guidelines.pdf";

export const Privacy_Url =
  "https://uploads-ssl.webflow.com/651750892fc953e528ca7b72/65a28b95390d57d916ca0b80_LYNX%20Privacy%20Policy.pdf";

export const Terms_Url =
  "https://uploads-ssl.webflow.com/651750892fc953e528ca7b72/65a28be0d84d81bc4859e400_LYNX%20Terms%20%26%20Conditions.pdf";
